export const baseUrl: string = process.env.REACT_APP_API_BASE_URL;
export const authHeaderName: string = "X-Custom-Auth";
export const signalRUrl: string = `${baseUrl}/signalr`;